import { createApi } from '@reduxjs/toolkit/query/react'
import { authHeaderAPI } from 'redux/_helpers/auth-header'
import { baseQueryWithErrorHandler } from 'redux/_helpers/custom-base-query'

export const ClientsAPI = createApi({
  reducerPath: 'ClientsAPI',
  baseQuery: baseQueryWithErrorHandler,
  tagTypes: ['ClientsAPI'],
  endpoints: builder => ({
    addClientAPI: builder.mutation({
      query: body => ({
        url: `/api/Client`,
        method: 'POST',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['ClientsAPI'],
    }),
    editClientAPI: builder.mutation({
      query: ({ body, id }) => ({
        url: `/api/Client/${id}`,
        method: 'PUT',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['ClientsAPI'],
    }),
    getAllClients: builder.query({
      query: (params: any) => ({
        url: `/api/Client`,
        method: 'GET',
        headers: authHeaderAPI(),
        params,
      }),
      providesTags: ['ClientsAPI'],
    }),
    // getHotelGeneralConfigration: builder.query({
    //   query: () => ({
    //     url: `/api/Configurations`,
    //     method: 'GET',
    //     headers: authHeaderAPI(),
    //   }),
    //   providesTags: ['ClientsAPI'],
    // }),
    getClientById: builder.query({
      query: id => ({
        url: `/api/Client/${id}`,
        method: 'GET',
        headers: authHeaderAPI(),
      }),
      providesTags: ['ClientsAPI'],
    }),

    deleteClient: builder.mutation({
      query: id => ({
        method: 'DELETE',
        url: `/api/Client/${id}`,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['ClientsAPI'],
    }),
  }),
})

export const {
  useGetAllClientsQuery,
  useAddClientAPIMutation,
  useGetClientByIdQuery,
  useEditClientAPIMutation,
  useDeleteClientMutation,
} = ClientsAPI
